var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from 'react';
import { setFilter, filterListener } from './Utils';
import { MultipleSelect } from '../forms';
import { PopUpMessage } from '../general';
import { Status } from '../general';
function FilterBoolean(props) {
    var attribute = props.attribute, componentId = props.componentId, rename = props.rename, zone = props.zone, setZone = props.setZone;
    var _a = useState([]), values = _a[0], setValues = _a[1];
    var _b = useState(false), disabled = _b[0], setDisabled = _b[1];
    var _c = useState(null), timeoutValue = _c[0], setTimeoutValue = _c[1];
    var _d = useState(''), errorMessage = _d[0], setErrorMessage = _d[1];
    var operator = 'in_list';
    var flipValues = function (val) {
        var convertedValues = [];
        for (var _i = 0, val_1 = val; _i < val_1.length; _i++) {
            var v = val_1[_i];
            switch (v) {
                case "True":
                    convertedValues.push("true");
                    continue;
                case "true":
                    convertedValues.push("True");
                    continue;
                case "False":
                    convertedValues.push("false");
                    continue;
                case "false":
                    convertedValues.push("False");
                    continue;
            }
        }
        return convertedValues;
    };
    filterListener({
        attribute: attribute,
        componentId: componentId,
        operators: [operator],
        zone: zone,
        setValue: setValues,
        setDisabled: setDisabled,
        emptyValue: [],
        zoneToValue: function (filterValue) {
            return flipValues(filterValue);
        }
    }, [zone]);
    var onFilter = function (input) {
        setValues(input);
        clearTimeout(timeoutValue);
        setTimeoutValue(setTimeout(function () {
            setValues(input);
            setFilter({
                operator: operator,
                value: flipValues(input),
                negate: false,
                attribute: attribute,
                componentId: componentId,
                zone: zone,
                valueExists: input.length !== 0,
            });
            setZone(__assign({}, zone));
        }, 800));
    };
    var renderItem = function (label) {
        switch (label) {
            case 'True':
                return (_jsx(Status, { text: "True", status: "success" }));
            case 'False':
                return (_jsx(Status, { text: "False", status: "danger" }));
        }
    };
    var renderValue = function (val) {
        return val.map(function (v) {
            return (_jsx("div", { children: renderItem(v) }, v));
        });
    };
    return (_jsxs("span", __assign({ className: 'tol-boolean-filter' }, { children: [_jsx(PopUpMessage, { type: 'danger', message: errorMessage, setMessage: setErrorMessage }), _jsx(MultipleSelect, { block: true, noSearch: true, data: ['True', 'False'], placeholder: rename, disabled: disabled, value: values, setValue: onFilter, onClick: function (e) { return e.stopPropagation(); }, renderMenuItem: renderItem, renderValue: renderValue })] })));
}
export default FilterBoolean;
